module.exports = __webpack_public_path__ + "static/illustrationCuisine-135a911815bdafb7eaaaf0e54142df6c.svg";